import { useEffect } from "react";
import { useAuth } from "src/hooks";
import { SetSentryUserContext } from "./SentryUtils";

export const UserContextSentry = (): null => {
    const { user, userAdminId } = useAuth();
    if (!user) {
        return null;
    }
    const tmpUser: any = user;
    tmpUser.adminId = userAdminId;
    tmpUser.id = tmpUser?.id?.toString();

    useEffect(() => {
        SetSentryUserContext(tmpUser);
    }, [user]);

    return null;
};
